/**
 * Magazines from the last shift before the plant closed. They stopped short.
 */

import type { Affix } from '@/sim/items/affixContract';

export const SHORT_SHIFT = {
  id: 'shortShift',
  slot: 'suffix',
  field: 'magazine',
  direction: -1,
  label: 'Reduced magazine size',
  nameWord: 'of the Short Shift',
  ranges: {
    common: { min: 0.06, max: 0.12 },
    uncommon: { min: 0.1, max: 0.18 },
    rare: { min: 0.15, max: 0.24 },
    exotic: { min: 0.2, max: 0.3 },
  },
} as const satisfies Affix;
